import { render, staticRenderFns } from "./TheContentContainer.vue?vue&type=template&id=635e8ead&"
import script from "./TheContentContainer.vue?vue&type=script&lang=ts&"
export * from "./TheContentContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TheContentContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports